// TrialNotificationBanner.jsx
import React, { useState, useEffect } from 'react';
import api from '../apiClient';

export default function TrialNotificationBanner({ licenseType, licenseData, onDismiss }) {
  const [showPaymentSetup, setShowPaymentSetup] = useState(false);
  const [loading, setLoading] = useState(false);

  if (!licenseData || !licenseData.trialEndingSoon) {
    return null;
  }

  if (licenseData.trialNotificationShown) {
    return null;
  }

  const daysRemaining = licenseData.daysRemainingInTrial || 0;
  const trialEndDate = licenseData.trialEnd 
    ? new Date(licenseData.trialEnd).toLocaleDateString()
    : 'soon';

  const handleDismiss = async () => {
    try {
      await api.post(`/api/company/licenses/${licenseType}/dismiss-trial-notification`);
      if (onDismiss) onDismiss();
    } catch (error) {
      console.error('Failed to dismiss notification:', error);
    }
  };

  const handleAddPayment = async () => {
    setLoading(true);
    try {
      // Call your existing backend route
      const response = await api.post('/api/company/licenses/portal');
      
      // Redirect to Stripe portal
      if (response.data && response.data.portal_url) {
        window.location.href = response.data.portal_url;
      } else {
        alert('Failed to open billing portal');
      }
    } catch (error) {
      console.error('Failed to open billing portal:', error);
      alert('Failed to open billing portal. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{
      backgroundColor: '#fef3c7',
      border: '1px solid #f59e0b',
      borderRadius: '8px',
      padding: '16px',
      marginBottom: '20px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between'
    }}>
      <div style={{ flex: 1 }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
          <span style={{ fontSize: '24px' }}>⏰</span>
          <div>
            <strong style={{ color: '#92400e' }}>
              Your trial ends in {daysRemaining} {daysRemaining === 1 ? 'day' : 'days'}
            </strong>
            <p style={{ margin: '4px 0 0 0', color: '#78350f', fontSize: '14px' }}>
              Trial expires on {trialEndDate}. Add a payment method to continue using this service.
            </p>
          </div>
        </div>
      </div>
      
      <div style={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
        <button
          onClick={handleAddPayment}
          style={{
            backgroundColor: '#3b82f6',
            color: 'white',
            border: 'none',
            padding: '10px 20px',
            borderRadius: '6px',
            cursor: 'pointer',
            fontWeight: '500',
            whiteSpace: 'nowrap'
          }}
        >
          Add Payment Method
        </button>
        
        <button
          onClick={handleDismiss}
          style={{
            backgroundColor: 'transparent',
            border: 'none',
            color: '#92400e',
            cursor: 'pointer',
            fontSize: '20px',
            padding: '0 8px'
          }}
          title="Dismiss"
        >
          ×
        </button>
      </div>
    </div>
  );
}